module.exports = __webpack_public_path__ + "files/cb5fc8f9bab4825d00f02bbb3e57cd1c.png";